import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.7071 15.7072C12.3166 16.0977 11.6834 16.0977 11.2929 15.7072L5.63604 10.0503C5.24551 9.65983 5.24551 9.02667 5.63604 8.63614C6.02656 8.24562 6.65973 8.24562 7.05025 8.63614L12 13.5859L16.9497 8.63614C17.3403 8.24562 17.9734 8.24562 18.364 8.63614C18.7545 9.02667 18.7545 9.65983 18.364 10.0503L12.7071 15.7072Z",
		transform: "rotate(-90 12 12)"
	})
});
export default SvgRightLine;
